import styled from 'styled-components'

export const BarrierInfoContainer = styled.div`
    i {
        color: ${({ theme }) => theme['blue-500']};
    }

    .barrier-info-row {
        display: flex;
        flex-direction: row;
        padding-top: 8px;
        padding-bottom: 8px;

        width: 100%;
        &.description {
            font-family: var(--font-bold);
        }
    }

    .barrier-info-col {
        display: flex;
        flex-direction: row;
    }

    .barrier {
        color: ${({ theme }) => theme['gray-900']};
        font-weight: ${({ theme }) => theme['font-bold']};
        font-size: 10px;
        &-info-id {
            padding-left: 4px;
            color: ${({ theme }) => theme['gray-600']};
            font-weight: ${({ theme }) => theme['font-regular']};
        }
        i {
            margin-left: auto;
            cursor: pointer;
            font-size: 14px;
        }
    }

    .description {
        color: ${({ theme }) => theme['gray-800']};
        font-weight: ${({ theme }) => theme['font-semibold']};
        font-size: 13px;
    }

    .info {
        font-size: 13px;
        text-align: left;

        .key {
            color: ${({ theme }) => theme['gray-600']};
            width: 50%;
        }

        .value {
            color: ${({ theme }) => theme['gray-800']};
        }
    }
`

export const InfoBarrierFlex = styled.div`
    display: flex;
    flex-direction: column;

    .select-barrier-label {
        margin-bottom: 20px;
    }
`
